import axios from "axios";
import toast from "react-hot-toast";
import { APPLICATION_KEY } from "./Configurations/Urls";
import useAuthStore from "./Zustand/Store/useAuthStore";

function mergeAuthHeaders(initHeaders) {
  const headers = new Headers();

  if (initHeaders) {
    if (initHeaders instanceof Headers) {
      initHeaders.forEach((value, key) => headers.set(key, value));
    } else if (Array.isArray(initHeaders)) {
      initHeaders.forEach(([key, value]) => headers.set(key, value));
    } else {
      Object.entries(initHeaders).forEach(([key, value]) => {
        if (value != null) headers.set(key, String(value));
      });
    }
  }

  const token = localStorage.getItem("token");
  if (token && !headers.has("Authorization") && !headers.has("authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (APPLICATION_KEY && !headers.has("X-Application-Key")) {
    headers.set("X-Application-Key", APPLICATION_KEY);
  }

  return headers;
}

/**
 * Attaches JWT and product key (ems) to every axios and fetch request.
 * Organization-scoped routes require auth:applicationusers + X-Application-Key.
 */
export function setupAxiosApplicationKey() {
  axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};

    const token = localStorage.getItem("token");
    if (token && !config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (APPLICATION_KEY && !config.headers["X-Application-Key"]) {
      config.headers["X-Application-Key"] = APPLICATION_KEY;
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url ?? "";
      const msg = error.response?.data?.message;
      const msgLower = typeof msg === "string" ? msg.toLowerCase() : "";
      const isAccessDenied =
        status === 403 &&
        (msgLower.includes("inactive for this organization") ||
          msgLower.includes("not enabled for") ||
          msgLower.includes("not active for your account") ||
          msgLower.includes("organization is not available for this application") ||
          msgLower.includes("subscription is inactive") ||
          msgLower.includes("subscription has expired"));

      if (
        isAccessDenied &&
        !url.includes("/api/auth/login") &&
        !url.includes("/auth/login")
      ) {
        toast.error(msg);
        useAuthStore.getState().logout();
        if (
          typeof window !== "undefined" &&
          !String(window.location.pathname).includes("/login")
        ) {
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );

  if (typeof window !== "undefined" && !window.__pmFetchPatched) {
    const originalFetch = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const headers = mergeAuthHeaders(init.headers);
      return originalFetch(input, { ...init, headers });
    };
    window.__pmFetchPatched = true;
  }
}
